<div id="app"><router-view></router-view><p>powerd by ilab.</p></div>